<button class="close-button" mat-icon-button [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title align="center">
    <b>
        {{ data.title }}
    </b>
</h2>
<mat-divider class="w-100-p"> </mat-divider>
<mat-dialog-content class="mat-typography">
    <h3>
        {{ data.msg }}
    </h3>
    <p *ngIf="data.mandatoryConfirmationPhrase">
        {{ "DIALOG.DESC" | translate }}
        <i>
            <b>{{ confirmationPhrase }}</b>
        </i>
    </p>

    <mat-form-field style="width: 100%" *ngIf="data.mandatoryConfirmationPhrase">
        <input [(ngModel)]="confirmation" matInput [placeholder]="confirmationPhrase" required />
        <mat-error *ngIf="!checkConfirmation()"></mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="type == 'cancel_accept' || type == 'yes_no'">
    <button mat-raised-button [mat-dialog-close]="false">
        {{ type == "cancel_accept" ? ("DIALOG.CANCEL" | translate) : ("DIALOG.NO" | translate) }}
    </button>
    <button
        [id]="'ok-button'"
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        [disabled]="data.mandatoryConfirmationPhrase && !checkConfirmation()"
    >
        {{ type == "cancel_accept" ? ("DIALOG.CONFIRM" | translate) : ("DIALOG.YES" | translate) }}
    </button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="type == 'onlyOk'">
    <button
        [id]="'ok-button'"
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        [disabled]="data.mandatoryConfirmationPhrase && !checkConfirmation()"
        
    >
        OK
    </button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="type == 'knowMore'">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ "DIALOG.KNOW_MORE" | translate }}</button>
</mat-dialog-actions>
